import { useContext } from 'react'
import { FeatureFlagsContext } from '@/components/featureFlagsProvider'

export function useFeatureFlags () {
  return useContext(FeatureFlagsContext)
}

export function useRfc13Announcements () {
  const flags = useFeatureFlags()
  return flags.rfc13Announcements
}

export function useRfc13AllTasks () {
  const flags = useFeatureFlags()
  return flags.rfc13AllTasks
}

export function useRfc13MessagesModule () {
  const flags = useFeatureFlags()
  return flags.rfc13MessagesModule
}



// WEBPACK FOOTER //
// ./src/hooks/useFeatureFlags.js